<span fxLayout="row" fxFill class="mat-app-background-1">
   <app-ytbesprechung-detail    [ytbesprechung]="ytbs$ | async"
                                [loading]="store.loading$ | async">

  </app-ytbesprechung-detail>
</span>
